export default __webpack_public_path__ + "static/media/about-banner-mobile.efe8563c.webp";